import styled from 'styled-components'

const StyledColortag = styled.span`
	display: inline-block;
	background-color: ${({ color }) => color || '#cdcdcd'};
	width: 8px;
	height: 100%;
`

export default StyledColortag
